"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VaccineRequestsList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const hui_1 = require("@mit/hui");
const react_router_dom_1 = require("react-router-dom");
const MedicalApi_1 = __importDefault(require("../../api/MedicalApi"));
const PersonDetailsDrawer_1 = __importDefault(require("../common/PersonDetailsDrawer"));
const VaccineRequestDrawer_1 = require("./VaccineRequestDrawer");
const moment = require("moment");
const VaccineRequestsListComponent = ({ peopleStore, covidNav, history }) => {
    var _a;
    const [showPerson, setShowPerson] = (0, react_1.useState)(false);
    const [showApprove, setShowApprove] = (0, react_1.useState)(false);
    const [person, setPerson] = (0, react_1.useState)();
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const [isUnauth, setUnauth] = (0, react_1.useState)(false);
    const [selectedExemption, setSelectedExemption] = (0, react_1.useState)();
    const [alertMessage, setAlertMessage] = (0, react_1.useState)({ text: "" });
    const [tabs, setTabs] = (0, react_1.useState)("Pending");
    const getStatus = () => {
        switch (tabs) {
            case "Pending":
                return "P";
            case "Rejected":
                return "R";
            case "Approved":
                return "A";
            case "More":
                return "M";
            case "All":
                return "";
            default:
                return "P,R,M";
        }
    };
    (0, react_1.useEffect)(() => {
        reloadDataVaccineExemption(getStatus());
    }, [tabs]);
    const getIconStatus = (status) => {
        if (status === "A")
            return (0, jsx_runtime_1.jsx)(hui_1.Icon, { icon: "check-circle", type: "solid", color: "green" });
        if (status === "P")
            return (0, jsx_runtime_1.jsx)(hui_1.Icon, { icon: "clock ", type: "light" });
        if (status === "R")
            return (0, jsx_runtime_1.jsx)(hui_1.Icon, { icon: "times-circle ", type: "solid", color: "red" });
        if (status === "M")
            return (0, jsx_runtime_1.jsx)(hui_1.Icon, { icon: "info-circle ", type: "light" });
    };
    const reloadDataVaccineExemption = (state) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        MedicalApi_1.default
            .fetchVaccineExemption(undefined, state)
            .then((res) => {
            if (res.error) {
                //todo: handle error
            }
            else if (res.unauth) {
                //setLoading(false);
                setUnauth(true);
            }
            else {
                setLoading(false);
                if (res.items) {
                    peopleStore.setVaccineRequestExemptionList(res.items);
                }
            }
        })
            .catch(() => { })
            .finally(() => {
            setLoading(false);
        });
    });
    const viewPersonClose = () => {
        setPerson(undefined);
        setShowPerson(false);
    };
    const showPersonInfo = (item) => {
        setShowPerson(true);
        setPerson(item);
    };
    const getClassName = (status) => {
        if (status.toLowerCase() === "open") {
            return "open-status";
        }
        else if (status.toLowerCase() === "new") {
            return "new-status";
        }
        return "";
    };
    const columns = [
        {
            id: "displayName",
            name: "Name",
            sortable: true,
            formatter: (item) => {
                return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "clickable", onClick: () => {
                        showPersonInfo(item);
                    } }, { children: (0, jsx_runtime_1.jsx)("span", { children: item.displayName }) })));
            },
            options: {
                demandPopin: true,
                minWidth: 600,
                popinText: "Name",
            },
            filterable: true,
            filterOptions: {
                type: "textbox",
                onFilter: (item, value) => {
                    var _a;
                    if (((_a = item.displayName) === null || _a === void 0 ? void 0 : _a.toLowerCase().indexOf(value === null || value === void 0 ? void 0 : value.toLowerCase())) !== -1)
                        return true;
                    return false;
                },
            },
        },
        {
            id: "mitId",
            name: "MIT ID",
            sortable: false,
            formatter: (item) => {
                return (0, jsx_runtime_1.jsx)("span", { children: item.mitId });
            },
            options: {
                demandPopin: true,
                minWidth: 600,
                popinText: "MIT ID",
            },
            filterable: false,
        },
        {
            id: "phoneNumber",
            name: "Phone Number",
            sortable: false,
            formatter: (item) => {
                return (0, jsx_runtime_1.jsx)("span", { children: item.phoneNumber });
            },
            options: {
                demandPopin: true,
                minWidth: 600,
                popinText: "Phone Number",
            },
            filterable: false,
        },
        {
            id: "email",
            name: "Email",
            sortable: false,
            formatter: (item) => {
                return (0, jsx_runtime_1.jsx)("span", { children: item.email });
            },
            options: {
                demandPopin: true,
                minWidth: 600,
                popinText: "Email",
            },
            filterable: false,
        },
        {
            id: "submissionDate",
            name: "Submission Date",
            sortable: true,
            formatter: (item) => {
                return (0, jsx_runtime_1.jsx)("span", { children: item.submissionDate ? moment.utc(item.submissionDate).local().format("MM/DD/YYYY h:mm a") : "-" });
            },
            options: {
                demandPopin: true,
                minWidth: 600,
                popinText: "Submission Date",
            },
            filterable: false,
        },
        {
            id: "personAff",
            name: "Person Type",
            sortable: true,
            formatter: (item) => {
                return (0, jsx_runtime_1.jsx)("span", { children: item.personType });
            },
            options: {
                demandPopin: true,
                minWidth: 600,
                popinText: "Person Type",
            },
            filterable: true,
            filterOptions: {
                type: "dropdown",
                createOptionsOffItems: true,
                onFilter: (item, value) => {
                    var _a;
                    if (((_a = item.personAff) === null || _a === void 0 ? void 0 : _a.toLowerCase().indexOf(value === null || value === void 0 ? void 0 : value.toLowerCase())) !== -1)
                        return true;
                    return false;
                },
            },
        },
        {
            id: "typeName",
            name: "Type",
            sortable: true,
            formatter: (item) => {
                return (0, jsx_runtime_1.jsx)("span", { children: item.typeName });
            },
            options: {
                demandPopin: true,
                minWidth: 600,
                popinText: "Type",
            },
            filterable: true,
            filterOptions: {
                type: "dropdown",
                createOptionsOffItems: true,
                onFilter: (item, value) => {
                    var _a;
                    if (((_a = item.typeName) === null || _a === void 0 ? void 0 : _a.toLowerCase().indexOf(value === null || value === void 0 ? void 0 : value.toLowerCase())) !== -1)
                        return true;
                    return false;
                },
            },
        },
        {
            id: "exemptFrom",
            name: "Exempt From",
            sortable: false,
            formatter: (item) => {
                return (0, jsx_runtime_1.jsx)("span", { children: item.exemptFrom });
            },
            options: {
                demandPopin: true,
                minWidth: 600,
                popinText: "Type",
            },
            filterable: false,
        },
        {
            id: "statusText",
            name: "Status",
            sortable: true,
            formatter: (item) => {
                return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "clickable", onClick: () => {
                        setSelectedExemption(item);
                        setShowApprove(true);
                    } }, { children: (0, jsx_runtime_1.jsxs)("span", { children: [getIconStatus(item.status), " ", item.statusText] }) })));
            },
            options: {
                demandPopin: true,
                minWidth: 600,
                popinText: "Status",
            },
            filterable: true,
            filterOptions: {
                type: "dropdown",
                createOptionsOffItems: true,
                onFilter: (item, value) => {
                    var _a;
                    if (((_a = item.statusText) === null || _a === void 0 ? void 0 : _a.toLowerCase().indexOf(value === null || value === void 0 ? void 0 : value.toLowerCase())) !== -1)
                        return true;
                    return false;
                },
            },
        },
        {
            id: "expiryDate",
            name: "Expiry Date",
            sortable: false,
            formatter: (item) => {
                const date = item.expiryDate ? moment(item.expiryDate).utc().format('ll') : '-';
                return (0, jsx_runtime_1.jsx)("span", { children: moment(date).isValid() ? date : '-' });
            },
            options: {
                demandPopin: true,
                minWidth: 600,
                popinText: "Type",
            },
            filterable: false,
        },
    ];
    const data = (_a = peopleStore.vaccineRequestExemptList) === null || _a === void 0 ? void 0 : _a.map((x) => {
        var _a;
        let item = Object.assign({}, x);
        item.submissionDate = (_a = item.submissionDate) !== null && _a !== void 0 ? _a : "";
        return item;
    }).sort((x, y) => {
        if (x.submissionDate === y.submissionDate)
            return 0;
        if (!x.submissionDate)
            return 1;
        if (!y.submissionDate)
            return -1;
        return moment(x.submissionDate).isBefore(moment(y.submissionDate)) ? 1 : -1;
    });
    const getSuccessText = (status, name) => {
        if (status === "A")
            return `Successfully Approved ${name}`;
        if (status === "R")
            return `Successfully Denied ${name}`;
        if (status === "M")
            return `Successfully Requested more info from ${name}`;
    };
    const switchTab = (tab) => {
        setTabs(tab);
    };
    let navItems = [
        {
            icon: "",
            iconOnly: false,
            text: "All",
            state: tabs === "All" ? hui_1.NavItemState.Active : hui_1.NavItemState.None,
            onClick: () => switchTab("All"),
        },
        {
            icon: "",
            iconOnly: false,
            text: "Pending",
            state: tabs === "Pending" ? hui_1.NavItemState.Active : hui_1.NavItemState.None,
            onClick: () => switchTab("Pending"),
        },
        {
            icon: "",
            iconOnly: false,
            text: "Need more info",
            state: tabs === "More" ? hui_1.NavItemState.Active : hui_1.NavItemState.None,
            onClick: () => switchTab("More"),
        },
        {
            icon: "",
            iconOnly: false,
            text: "Approved",
            state: tabs === "Approved" ? hui_1.NavItemState.Active : hui_1.NavItemState.None,
            onClick: () => switchTab("Approved"),
        },
        {
            icon: "",
            iconOnly: false,
            text: "Denied",
            state: tabs === "Rejected" ? hui_1.NavItemState.Active : hui_1.NavItemState.None,
            onClick: () => switchTab("Rejected"),
        },
    ];
    if (isUnauth)
        return (0, jsx_runtime_1.jsx)(hui_1.Error, { context: hui_1.ErrorContext.Component, message: "Not Authorized", type: hui_1.ErrorType.AccessDenied });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "contacttracingtable" }, { children: (0, jsx_runtime_1.jsx)(hui_1.NavBar, { tabs: navItems, type: hui_1.NavBarTypes.Text, itemAlignment: hui_1.ItemAlignment.Left }) })), alertMessage.text && (0, jsx_runtime_1.jsx)(hui_1.Alert, Object.assign({ icon: "check-circle" }, alertMessage)), (0, jsx_runtime_1.jsx)(hui_1.AdvancedTable, { columns: columns, items: data ? data : [], showExportButton: false, showFilterButton: true, isLoading: isLoading || covidNav.globalTableIsLoading, maxRows: 1000, showNoData: true, noDataText: "No requests available.", 
                //actionButtons={actionButtons}
                theme: "medical", sort: { sortDirection: "asc", sortedBy: "submissionDate" }, sortStateOptions: {
                    enabled: true,
                    key: "covid-medical-vaccine-exemptions",
                } }), (0, jsx_runtime_1.jsx)(PersonDetailsDrawer_1.default, { id: person === null || person === void 0 ? void 0 : person.mitId, show: showPerson, onClose: viewPersonClose }), (0, jsx_runtime_1.jsx)(VaccineRequestDrawer_1.VaccineRequestDrawer, { onApproveOrReject: (status, name) => {
                    setAlertMessage({ text: getSuccessText(status, name), type: "success" });
                    setTimeout(() => {
                        setAlertMessage({ text: "" });
                    }, 5000);
                    reloadDataVaccineExemption(getStatus());
                }, show: showApprove, onClose: () => setShowApprove(false), mitId: selectedExemption === null || selectedExemption === void 0 ? void 0 : selectedExemption.mitId, exemption: selectedExemption })] }));
};
exports.VaccineRequestsList = (0, react_router_dom_1.withRouter)((0, mobx_react_1.inject)("peopleStore", "covidNav", "searchUser")((0, mobx_react_1.observer)(VaccineRequestsListComponent)));
